import axios from 'axios'

import { getLocalStorageItem } from '~/app/hooks/useLocalStorage'

export const apiHost = import.meta.env.VITE_API_HOST || window.location.origin
export const apiPrefix = '/api'
export const apiBaseUrl = `${apiHost}${apiPrefix}`

const apiBase = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    common: {
      'Accept': 'application/json',
    },
  },
  validateStatus: (status) => {
    // Allow 422 API validation issues to be treated as valid so we can show
    // errors in form
    return status === 422 || (status >= 200 && status < 400)
  },
})

// Add a request interceptor to add token when present
apiBase.interceptors.request.use(
  (config) => {
    const token = getLocalStorageItem('accessToken')
    if (token)
      config.headers.Authorization = 'Bearer ' + token

    return config
  })

export default apiBase
